const ITEMS = [
    "Branding",
    "Visual Design",
    "Editorial",
    "Social Media",
    "Creative Direction",
    "Content Creation",
    "Digital Design",
];

export default function Marquee({ dark = false }) {
    const row = ITEMS.map((i) => `${i} —`).join(" ");
    return (
        <div
            data-testid="editorial-marquee"
            className="overflow-hidden border-y border-white/10 py-5 sm:py-7"
            aria-hidden="true"
        >
            <div className="animate-marquee flex w-max whitespace-nowrap">
                {[0, 1].map((n) => (
                    <span
                        key={n}
                        className={`font-display text-2xl font-bold uppercase tracking-tight sm:text-4xl ${
                            dark ? "text-white/10" : "text-white/15"
                        }`}
                    >
                        {row}&nbsp;
                    </span>
                ))}
            </div>
        </div>
    );
}
